module.exports = __webpack_public_path__ + "img/mollie.83baad8f.svg";